module.exports = "/_next/static/images/plates-6e6fdffb8a81b1c1ce2b843a0760db89.png.webp";